import { OverlayContainer } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetDataService } from './shared/services/get-data.service';
import { RequestFormService } from './shared/services/request-form.service';
import { AutoUnsubscribeComponent } from './shared/utils/auto-unsubscribe.component';
import { HideToolbarService } from './shared/services/hideToolbar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends AutoUnsubscribeComponent {
  title = 'frontend-lms-formularios';
  @HostBinding('class') className = '';
  toggleControl = new FormControl(false);
  public opened = false;
  public search = false;
  public referralBoolean = false;
  public requestNumber$!: string | undefined;
  public referralCode$!: string | undefined;
  public referralName$!: string | undefined;
  public creditType$!: string;
  public gid$!: string;
  public darkClassName = 'theme-alternate';
  public authorization!: boolean;
  public approvePrefilter!: string;
  public country!: string;
  public hidePageConfirmationPlatform = false;
  public hidePageConfirmationPlatformDae = false;
  public editLto = false;

  constructor(
    private overlay: OverlayContainer,
    private requestFormService: RequestFormService,
    private activatedRouter: ActivatedRoute,
    private getDataService: GetDataService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private hideToolbarFormService: HideToolbarService
  ) {
    super();
    this.activatedRouter.queryParams.subscribe((params) => {
      if (params['referralCode']) {
        sessionStorage.removeItem('referralCode');
        this.referralCode$ = params['referralCode'];
        getDataService.getReferralCode(this.referralCode$!).subscribe((res) => {
          this.referralName$ = res.userFullName;
        });
        sessionStorage.setItem('referralCode', this.referralCode$!);
        this.referralBoolean = true;
      } else {
        sessionStorage.removeItem('referralCode');
      }
      this.gid$ = params['gid'];
      if (params['gid']) {
        sessionStorage.setItem('gid', this.gid$);
      }
      this.creditType$ = params['creditType'];

      if (
        params['creditType'] ||
        (sessionStorage.getItem('requestNumber') && this.creditType$)
      ) {
        sessionStorage.setItem('creditType', this.creditType$);
      }
      this.authorization = params['authorization'];
      this.country = sessionStorage.getItem('language')!;
      this.approvePrefilter = sessionStorage.getItem('approvePrefilter')!;
    });

    const pathname = window.location.pathname;

    if (
      pathname === '/confirmacion-solicitud' ||
      pathname === '/confirmacion-solicitud-2' ||
      pathname === '/mx/solicitud/form/bienvenida' ||
      pathname === '/mx/solicitud/form/carga-documentos') {
      this.hidePageConfirmationPlatform = true;
    }

    this.hideToolbarFormService.getHideToolbarFormObservable().subscribe((resp) => {
      this.hidePageConfirmationPlatform = resp;
    });

    this.hideToolbarFormService.hideToolbarFromFormMode$.subscribe((resp) => {
      this.hidePageConfirmationPlatformDae = resp;
    });
  }

  ngOnInit(): void {
    this.requestFormService.getDataFormObservable().subscribe((resp) => {
      this.requestNumber$ = resp.requestNumber;
    });
    this.requestFormService.getUpdateFormObservable().subscribe((resp) => {
      this.creditType$ = resp.creditType.code;
      this.editLto = true;
    });
    if (window.location.href.includes('busqueda')) {
      this.search = true;
    } else {
      this.search = false;
    }

    if (!this.search) {
      sessionStorage.removeItem('requestNumber');
      sessionStorage.removeItem('email');
    }
    this.toggleControl.valueChanges.subscribe((darkMode) => {
      this.changeDarkMode(darkMode!);
    });
    this.toggleControl.setValue(sessionStorage.getItem('darkMode') === 'true');
  }

  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    this.requestNumber$ =
      sessionStorage.getItem('requestNumber')?.toString() ||
      this.requestNumber$?.toString();
    if (window.location.href.includes('busqueda')) {
      setTimeout(() => {
        this.search = true;
      }, 0);
    } else {
      setTimeout(() => {
        this.search = false;
      }, 0);
    }

    if (sessionStorage.getItem('referralCode') && !this.referralBoolean) {
      this.referralCode$ = sessionStorage.getItem('referralCode')!;
      const getReferralCode$ = this.getDataService
        .getReferralCode(this.referralCode$!)
        .subscribe((res) => {
          this.referralName$ = res.userFullName;
        });
      this.referralBoolean = true;
      this.subscriptions.push(getReferralCode$);
    }

    this.changeDetectorRef.detectChanges();
  }

  changeDarkMode(darkMode: boolean) {
    sessionStorage.setItem('darkMode', darkMode.toString());

    this.className = darkMode ? this.darkClassName : '';
    if (this.className) {
      if (darkMode) {
        this.overlay.getContainerElement().classList.add(this.className);
      } else {
        this.overlay.getContainerElement().classList.remove(this.className);
      }
    }
  }
}
